export default {"src":"https://images-cdn.curipod.com/d-bdb94e66/_next/static/media/loveEmoji.900e2270.svg","height":174,"width":150};